import React, { useCallback } from 'react';
var css = {
  "widget": "oalp-3a0hj",
  "cta": "oalp-16uV6",
  "hoverClass": "oalp-3TlaY",
  "infoChip": "oalp-1jj30"
};
import CTA from "../../Components/CTA/CTA";
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import TitleComponent from "../../Components/Title/Title";
import { trackingHelper } from "../../Helpers/trackingHelper";
import { EVALUATION_STATES_TRACKING, FLOW_TYPES } from "../../Constants/evaluation";
import useErrorCookie from "../../CustomHooks/useErrorCookie/useErrorCookie";
import useValuationResult from "../BookAnAppointment/useValuationResults";
import withConfig from "./../../ComponentDependency/withConfig";
import SubSection from "../../Components/SubSection/SubSection";
export var StaticImageWithCTAAndDesc = function StaticImageWithCTAAndDesc(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    image = _ref$data.image,
    cta = _ref$data.cta,
    brandText = _ref$data.brandText,
    subText = _ref$data.subText,
    infoChip = _ref$data.infoChip,
    showCarDetails = _ref$data.showCarDetails,
    subSection = _ref$data.subSection,
    metadata = _ref.metadata,
    handleCallbackClick = _ref.handleCallbackClick,
    handleIconClick = _ref.handleIconClick,
    track = _ref.track,
    locationId = _ref.locationId,
    origin = _ref.origin,
    landingURLSearch = _ref.landingURLSearch,
    params = _ref.params,
    config = _ref.config;
  var _ref2 = metadata || {},
    style = _ref2.style;
  var widgetName = name;
  useErrorCookie({
    widgetName: widgetName
  });
  var onTrack = useCallback(function (eventName) {
    trackingHelper({
      eventName: eventName,
      track: track,
      locationId: locationId,
      origin: origin,
      select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
      landingURLSearch: landingURLSearch,
      params: params,
      config: config.get()
    });
  }, [track, locationId, origin, landingURLSearch, params, config]);
  var subTitle = subText && {
    __html: subText.text
  };
  var _useValuationResult = useValuationResult(),
    displayName = _useValuationResult.displayName,
    displayYear = _useValuationResult.displayYear;
  var renderBrandText = function renderBrandText() {
    if (brandText) {
      if (brandText.heading) {
        return /*#__PURE__*/React.createElement(TitleComponent, {
          title: brandText,
          className: css.brandText
        });
      }
      return /*#__PURE__*/React.createElement("p", {
        className: css.brandText,
        style: brandText.style
      }, brandText.text);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css.widget,
    style: style
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  }), infoChip && /*#__PURE__*/React.createElement("p", {
    className: css.infoChip,
    style: infoChip.style
  }, infoChip.text), renderBrandText(), showCarDetails && /*#__PURE__*/React.createElement("p", {
    style: showCarDetails.style
  }, displayName, " ", displayYear), subText && (subText.showBg ? /*#__PURE__*/React.createElement("div", {
    style: subText.bgStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: css.subText,
    style: subText.style,
    dangerouslySetInnerHTML: subTitle
  })) : /*#__PURE__*/React.createElement("p", {
    className: css.subText,
    style: subText.style,
    dangerouslySetInnerHTML: subTitle
  })), subSection && /*#__PURE__*/React.createElement(SubSection, Object.assign({}, subSection)), cta && cta.buttons && /*#__PURE__*/React.createElement("div", {
    className: css.cta,
    style: cta.style
  }, cta.buttons.map(function (button, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: "widget_".concat(button.name || name, "_cta_").concat(idx),
      button: button,
      widgetKey: name,
      track: track,
      locationId: locationId,
      "data-aut-id": button.name || name,
      metadata: metadata,
      customClass: css.hoverClass,
      onTrack: onTrack,
      handleCallbackClick: handleCallbackClick,
      handleIconClick: handleIconClick,
      select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
      flow_type: FLOW_TYPES.NO_DRAFT
    });
  })));
};
export default withConfig(StaticImageWithCTAAndDesc);